import React from "react";
import { useObserver } from "mobx-react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { PrimaryButton, RegularButton } from "@components";
import { BisnodeLookupStore } from "./BisnodeLookupStore";
import BisnodeLookupTable from "./BisnodeLookupTable";

type Props = {
  store: BisnodeLookupStore;
};

export function BisnodeLookup(props: Props) {
  const { store } = props;

  return useObserver(() => (
    <Dialog open={store.open} maxWidth={false} onClose={store.onCancel}>
      <DialogTitle>{locale.BisnodeLookup}</DialogTitle>
      <DialogContent>
        <BisnodeLookupTable
          allChecked={store.allChecked}
          allDisabled={store.allDisabled}
          items={store.lookupItems}
          onCheck={store.checkItem}
          onCheckAll={store.checkAll}
        />
      </DialogContent>

      <DialogActions>
        <RegularButton onClick={store.onCancel}>{locale.Cancel}</RegularButton>

        <PrimaryButton type="submit" onClick={store.onSubmit}>
          {locale.OK}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  ));
}
